export const CREATE_OPPORTUNITY = 'CREATE_OPPORTUNITY'
export const GET_OPPORTUNITY = 'GET_OPPORTUNITY'
export const GET_OPPORTUNITIES = 'GET_OPPORTUNITIES'
export const OPPORTUNITY_LOADING = 'OPPORTUNITY_LOADING'
export const DELETE_OPPORTUNITY = 'DELETE_OPPORTUNITY'
export const UPDATE_OPPORTUNITY = 'UPDATE_OPPORTUNITY'
export const OPPORTUNITY_EDITING = 'OPPORTUNITY_EDITING'
